import { FormattedMessage } from 'react-intl';

const intlPrefix = 'search';

export const NoResults = (
  <FormattedMessage
    defaultMessage='No results'
    id={`${intlPrefix}.noResults`}
  />
);

export const TryDifferentSearch = (
  <FormattedMessage
    defaultMessage='Please try a different search selection or browse the below options.'
    id={`${intlPrefix}.tryDifferentSearch`}
  />
);
